import { RentalPropertyCalculator } from "../Apps/RentalPropertyCalculator"

function AppRentalPropertyCalculator() {

  return (
    <RentalPropertyCalculator />
  )
}

export default AppRentalPropertyCalculator

